/* eslint-disable no-secrets/no-secrets */
/* eslint-disable react/prop-types */
import React from "react";
import PropTypes from "prop-types";
import { Field } from "redux-form";
import { renderField, YesNo, YesNoChecks } from "../components";
import { validateRequired } from "../validation";

const StyledForm = props => {
  const {
    renderValue,
    isQ1FieldsRequired,
    isOtherExtremeSportFieldRequired,
    isQ2FieldsRequired,
    isQ3FieldsRequired,
    isQ4FieldsRequired,
    isQ5FieldsRequired,
    isQ6FieldsRequired,
    isQ7FieldsRequired,
    isQ8FieldsRequired,
    isQ9FieldsRequired,
    isQ10aFieldsRequired,
    isQ10bFieldsRequired,
    isQ10cFieldsRequired,
    isQ10dFieldsRequired,
    isQ10eFieldsRequired,
    isPregnantMonthFieldRequired,
    isQ11FieldsRequired,
  } = props;

  const renderTextFieldList = (
    fields,
    headerText = "If ‘Yes’, please provide details as follows:",
    style,
    required = false
  ) => {
    return (
      <React.Fragment>
        <div className="text-fields-wrapper">{headerText}</div>
        {fields.map(({ text, name }, key) => (
          <div key={key} className="text-fields-wrapper">
            <div>{`${text} `} </div>
            <Field
              showOuterDiv={false}
              name={name}
              component={renderField}
              type="text"
              style={style}
              validate={required && [validateRequired]}
            />
          </div>
        ))}
      </React.Fragment>
    );
  };

  const renderTableFieldList = (
    fields,
    rows = 3,
    headerText = "If ‘Yes’, please provide details as follows:",
    style,
    required = false
  ) => {
    return (
      <React.Fragment>
        <div className="text-fields-wrapper">{headerText}</div>
        <table>
          <tr style={{ textAlign: "center" }}>
            {fields.map(({ label, width }, key) => (
              <td key={key} width={width}>
                {label}
              </td>
            ))}
          </tr>
          {Array(rows)
            .fill()
            .map((_, rowKey) => (
              <tr key={rowKey}>
                {fields.map(({ fieldName }, fieldKey) => (
                  <td key={fieldKey}>
                    {
                      <Field
                        showOuterDiv={false}
                        name={`${fieldName}${rowKey + 1}`}
                        component={renderField}
                        type="text"
                        style={style}
                        validate={rowKey === 0 && required && [validateRequired]}
                      />
                    }
                  </td>
                ))}
              </tr>
            ))}
        </table>
      </React.Fragment>
    );
  };

  const renderSingleQuestion = (
    {
      fields,
      tableFields,
      question,
      name,
      number,
      fieldText,
      showMedicalReportLabel = false,
      nested = false,
      isQuestionRaw = true,
    },
    style,
    required = false
  ) => {
    return (
      <fieldset>
        <div className={`${nested ? "" : "border--default"} text--left`}>
          <div className="row-cotainer">
            <span className="empty-placeholder">{number}</span>
            <div>
              <YesNoChecks
                questionDesc={question}
                name={name}
                isQuestionRaw={isQuestionRaw}
                validate={[validateRequired]}
              />
              {fields && renderTextFieldList(fields, fieldText, style, required)}
              {tableFields && renderTableFieldList(tableFields, 3, fieldText, style, required)}
              {showMedicalReportLabel && (
                <div className="text-fields-wrapper">
                  Medical Report available? No / Yes (please provide a copy)
                </div>
              )}
            </div>
          </div>
        </div>
      </fieldset>
    );
  };

  return (
    <form method="post" action="#">
      <fieldset>
        <table>
          <tbody>
            <tr>
              <td width="60%" className="text--left">
                <div className="bold-text">Name of Company</div>
                <div id="RO_CompanyName">
                  {renderValue({
                    fieldName: "CompanyName",
                    fieldFormat: "text",
                  })}
                </div>
              </td>
              <td>
                <div className="bold-text">Group Policy No.</div>
                <div id="RO_PolicyNumber">
                  {renderValue({
                    fieldName: "PolicyNumber",
                    fieldFormat: "text",
                  })}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </fieldset>
      <fieldset>
        <h3>Details of Employee</h3>
        <table className="details-of-employee-table">
          <tbody>
            <tr>
              <td colSpan={2} width="60%">
                Full Name of Employee in Block (as shown in NRIC – underline surname)
                <div id="RO_EmployeeName" style={{ textTransform: "uppercase" }}>
                  {renderValue({
                    fieldName: "EmployeeName",
                    fieldFormat: "text",
                  })}
                </div>
              </td>
              <td>
                NRIC/FIN/Passport No
                <div id="RO_Identification">
                  {renderValue({
                    fieldName: "Identification",
                    fieldFormat: "text",
                  })}
                </div>
              </td>
              <td>
                Date of Birth
                <div id="RO_BirthDate">
                  {renderValue({
                    fieldName: "BirthDate",
                    fieldFormat: "date",
                  })}
                </div>
              </td>
            </tr>
            <tr>
              <td>
                Occupation
                <Field
                  name="JobTitle"
                  type="text"
                  component={renderField}
                  label="JobTitle"
                  validate={[validateRequired]}
                />
              </td>
              <td>
                Date of Employment
                <div id="RO_JoinDate">
                  {renderValue({
                    fieldName: "JoinDate",
                    fieldFormat: "date",
                  })}
                </div>
              </td>
              <td>
                Gender
                <div id="RO_Gender">
                  {renderValue({
                    fieldName: "Gender",
                    fieldFormat: "text",
                  })}
                </div>
              </td>
              <td>
                Height (cm)
                <Field
                  name="Height"
                  type="text"
                  component={renderField}
                  label="Height"
                  validate={[validateRequired]}
                />
              </td>
            </tr>
            <tr>
              <td>
                Nationality
                <div id="RO_Nationality">
                  {renderValue({
                    fieldName: "Nationality",
                    fieldFormat: "text",
                  })}
                </div>
              </td>
              <td>
                Country of Residence
                <Field
                  name="Residence"
                  type="text"
                  component={renderField}
                  label="Residence"
                  validate={[validateRequired]}
                />
              </td>
              <td>
                Marital Status
                <div id="RO_MaritalStatus">
                  {renderValue({
                    fieldName: "MaritalStatus",
                    fieldFormat: "text",
                  })}
                </div>
              </td>
              <td>
                Weight (kg)
                <Field
                  name="Weight"
                  type="text"
                  component={renderField}
                  label="Weight"
                  validate={[validateRequired]}
                />
              </td>
            </tr>
          </tbody>
        </table>
      </fieldset>
      <fieldset>
        <div className="row-cotainer border--default text--left">
          <span className="empty-placeholder" />
          <div>
            <h2 style={{ display: "inline", fontSize: "1.5rem", textTransform: "none" }}>
              Health Declaration
            </h2>
            <div className="row red-text">
              <div>
                Please answer all questions and kindly counter-sign (if any alteration made)
              </div>
              <div>
                <i>(Please tick accordingly)</i>
              </div>
            </div>
          </div>
        </div>
      </fieldset>
      <fieldset>
        <div className="border--default text--left">
          <div className="row-cotainer">
            <span className="empty-placeholder">1</span>
            <div>
              <div>Do you engage in any of the following?</div>
              <YesNoChecks
                questionDesc="- Private Flying (Pilot / Passenger)"
                name="AdventurePrivateFlying"
                validate={[validateRequired]}
              />
              <YesNoChecks
                questionDesc="- Scuba Diving"
                name="AdventureScubaDiving"
                validate={[validateRequired]}
              />
              <YesNoChecks
                questionDesc="- Mountaineering / Outdoor Rock Climbing"
                name="Mountaineering"
                validate={[validateRequired]}
              />
              <YesNoChecks
                questionDesc="- Parachuting / Sky Diving"
                name="AdventureParachuting"
                validate={[validateRequired]}
              />
              <YesNoChecks
                questionDesc="- Racing"
                name="AdventureRacing"
                validate={[validateRequired]}
              />
              <YesNoChecks
                isQuestionRaw={false}
                questionDesc={
                  <div style={{ display: "flex" }}>
                    - Other extreme sports (please specify:{" "}
                    <Field
                      name="AdventureOtherExtremeSportName"
                      component={renderField}
                      type="text"
                      style={{
                        borderRadius: "0",
                        borderLeft: "none",
                        borderRight: "none",
                        borderTop: "none",
                      }}
                      validate={isOtherExtremeSportFieldRequired && [validateRequired]}
                    />
                    )
                  </div>
                }
                name="AdventureOtherExtreme"
                validate={[validateRequired]}
              />
              {renderTextFieldList(
                [
                  { name: "AdventureLocation", text: "Location of activity:" },
                  { name: "AdventureFrequency", text: "Frequency of activity:" },
                  { name: "AdventureDepthDived", text: "Depth Dived (if applicable):" },
                ],
                "If ‘Yes’ for any activity stated above, please provide details as follows:",
                {},
                isQ1FieldsRequired
              )}
            </div>
          </div>
        </div>
      </fieldset>
      {renderSingleQuestion(
        {
          question:
            "Have you taken narcotics, any habit forming drugs or ever been treated for drug or alcohol addiction?",
          number: 2,
          name: "DrugAddiction",
          fields: [
            { name: "DrugAddictionSubstance", text: "Name of substance:" },
            { name: "DrugAddictionDate", text: "Date of Treatment:" },
            { name: "DrugAddictionType", text: "Type of Treatment:" },
            { name: "DrugAddictionDoctor", text: "Name & Address of Doctor consulted:" },
          ],
        },
        {},
        isQ2FieldsRequired
      )}
      {renderSingleQuestion(
        {
          question:
            "Do you have any health or life insurance application that has been rejected, postponed or accepted at special rates or terms by any insurance company?",
          number: 3,
          name: "Exclusions",
          fields: [
            { name: "ExclusionsDate", text: "Date of Application:" },
            { name: "ExclusionsType", text: "Type of Application:" },
            { name: "ExclusionsReason", text: "Reason for Special Terms:" },
          ],
        },
        {},
        isQ3FieldsRequired
      )}
      {renderSingleQuestion(
        {
          question:
            "Have you in the <em>last 3 months</em> had any of the following symptoms for more than one week continuously: fatigue, weight loss, diarrhoea, enlarged nodes or unusual skin lesions?",
          number: 4,
          name: "WeightLoss",
          fields: [
            { name: "WeightLossDate", text: "Date:" },
            { name: "WeightLossDiagnosis", text: "Diagnosis:" },
            { name: "WeightLossTreatment", text: "Treatment:" },
            { name: "WeightLossDoctor", text: "Name & Address of Doctor consulted:" },
          ],
        },
        {},
        isQ4FieldsRequired
      )}
      {renderSingleQuestion(
        {
          question: "Do you smoke any cigarettes?",
          number: 5,
          name: "Smoke",
          fields: [
            { name: "SmokeYears", text: "No. of years smoke:" },
            { name: "SmokeQuantity", text: "No. of sticks smoked (per day):" },
          ],
        },
        {},
        isQ5FieldsRequired
      )}
      {renderSingleQuestion(
        {
          question: "Do you consume alcohol?",
          number: 6,
          name: "Alcohol",
          fields: [
            { name: "AlcoholType", text: "Type of Alcohol:" },
            { name: "AlcoholQuantity", text: "Quantity:" },
            { name: "AlcoholFrequency", text: "Frequency (per week):" },
          ],
        },
        {},
        isQ6FieldsRequired
      )}
      {renderSingleQuestion(
        {
          question:
            "Have you or your spouse, ever been told to have, received any medical advice, counseling or treatment in connection with sexually transmitted disease, AIDS, AIDS Related Complex or any other AIDS related conditions?",
          number: 7,
          name: "SexualDisease",
          fields: [
            { name: "SexualDiseaseDate", text: "Date:" },
            { name: "SexualDiseaseRelationship", text: "Relationship:" },
            { name: "SexualDiseaseDiagnosis", text: "Diagnosis:" },
            { name: "SexualDiseaseTreatment", text: "Treatment:" },
            { name: "SexualDiseaseDoctor", text: "Name & Address of Doctor consulted:" },
          ],
        },
        {},
        isQ7FieldsRequired
      )}
      {renderSingleQuestion(
        {
          question:
            "In the past 5 years, have you attended to any tests such as X ray, ultrasound, CT scan, biopsy, electro-cardiogram (ECG), endoscopy, blood or urine test?",
          number: 8,
          name: "DiagnosisInfo",
          fields: [
            { name: "DiagnosisInfoDate", text: "Date of test(s) done:" },
            { name: "DiagnosisInfoType", text: "Type of test(s) done:" },
            { name: "DiagnosisInfoReason", text: "Reason for the test(s) done:" },
            { name: "DiagnosisInfoResult", text: "Result of the test(s) done:" },
            { name: "DiagnosisInfoTreatment", text: "Type of treatment:" },
            { name: "DiagnosisInfoDoctor", text: "Name & Address of Doctor consulted:" },
          ],
          showMedicalReportLabel: true,
        },
        {},
        isQ8FieldsRequired
      )}
      {renderSingleQuestion(
        {
          question:
            "Have either of your natural parents or siblings died or suffered from cancer, heart disease, stroke, high blood pressure, diabetes, kidney disease, mental disorder, dementia, tuberculosis, Down’s syndrome or any hereditary disease?",
          number: 9,
          name: "FamilyHistory",
          tableFields: [
            { label: "Relationship", fieldName: "FamilyRelationship", width: "30%" },
            {
              label: "Condition/Cause of Death",
              fieldName: "FamilyMedicalCondition",
              width: "35%",
            },
            { label: "Age of Onset", fieldName: "FamilyAgeAtDiagnosis", width: "15%" },
            { label: "Age of Death(if deceased)", fieldName: "FamilyAgeAtDeath", width: "20%" },
          ],
        },
        {},
        isQ9FieldsRequired
      )}
      <fieldset>
        <div className="border--default text--left">
          <div className="row-cotainer">
            <span className="empty-placeholder">10</span>
            <div>
              <div style={{ fontWeight: "bold" }}>For Female Insured only</div>
              {renderSingleQuestion(
                {
                  question:
                    "Have you ever had any abnormal pap smear test or been told by a doctor to have a repeat pap smear within the next 6 months?",
                  number: "a)",
                  name: "PapSmear",
                  fields: [
                    { name: "PapSmearDate", text: "Date of test done:" },
                    { name: "PapSmearResult", text: "Result of the test done:" },
                    { name: "PapSmearDiagnosis", text: "Diagnosis:" },
                    { name: "PapSmearType", text: "Type of treatment:" },
                    { name: "PapSmearDoctor", text: "Name & Address of Doctor consulted:" },
                  ],
                  showMedicalReportLabel: true,
                  nested: true,
                },
                {},
                isQ10aFieldsRequired
              )}
              {renderSingleQuestion(
                {
                  question:
                    "Have you had an abnormal mammogram or been advised to have mammogram, ultrasound, biopsy, operation of the breasts, ultrasound of pelvis or attended to any other gynecological investigations?",
                  number: "b)",
                  name: "Gynaecological",
                  fields: [
                    { name: "GynaecologicalDate", text: "Date of test(s) done:" },
                    { name: "GynaecologicalType", text: "Type of test(s) done:" },
                    { name: "GynaecologicalResult", text: "Result of the test done:" },
                    { name: "GynaecologicalDiagnosis", text: "Diagnosis:" },
                    { name: "GynaecologicalTreatment", text: "Type of treatment:" },
                    { name: "GynaecologicalDoctor", text: "Name & Address of Doctor consulted:" },
                  ],
                  showMedicalReportLabel: true,
                  nested: true,
                },
                {},
                isQ10bFieldsRequired
              )}
              {renderSingleQuestion(
                {
                  question:
                    "Have you ever consulted a doctor for irregular, painful menstruation or other problem(s) involving the female organs?",
                  number: "c)",
                  name: "MenstruationDisorder",
                  fields: [
                    { name: "MenstruationDisorderDate", text: "Date:" },
                    { name: "MenstruationDisorderDiagnosis", text: "Diagnosis:" },
                    { name: "MenstruationDisorderType", text: "Type of treatment:" },
                    {
                      name: "MenstruationDisorderDoctor",
                      text: "Name & Address of Doctor consulted:",
                    },
                  ],
                  showMedicalReportLabel: true,
                  nested: true,
                },
                {},
                isQ10cFieldsRequired
              )}
              {renderSingleQuestion(
                {
                  question: "Have you ever suffered any complication of pregnancy?",
                  number: "d)",
                  name: "ComplicationOfPregnancy",
                  fields: [
                    { name: "ComplicationOfPregnancyDate", text: "Date:" },
                    { name: "ComplicationOfPregnancyDiagnosis", text: "Diagnosis:" },
                    { name: "ComplicationOfPregnancyType", text: "Type of treatment:" },
                    {
                      name: "ComplicationOfPregnancyDoctor",
                      text: "Name & Address of Doctor consulted:",
                    },
                  ],
                  showMedicalReportLabel: true,
                  nested: true,
                },
                {},
                isQ10dFieldsRequired
              )}
              {renderSingleQuestion(
                {
                  question: (
                    <div style={{ display: "flex", whiteSpace: "nowrap" }}>
                      <span>
                        Are you currently pregnant? <em> If ‘Yes’, please state no. of months</em>
                      </span>{" "}
                      <div style={{ width: "40px", marginLeft: "8px" }}>
                        <Field
                          name="EmpPregnantDurationValue"
                          component={renderField}
                          showOuterDiv={false}
                          type="text"
                          width="50px"
                          style={{
                            borderRadius: "0",
                            borderLeft: "none",
                            borderRight: "none",
                            borderTop: "none",
                          }}
                          validate={isPregnantMonthFieldRequired && [validateRequired]}
                        />
                      </div>
                      )
                    </div>
                  ),
                  number: "e)",
                  name: "Pregnant",
                  nested: true,
                  isQuestionRaw: false,
                },
                {},
                isQ10eFieldsRequired
              )}
            </div>
          </div>
        </div>
      </fieldset>
      <fieldset>
        <div className="border--default text--left">
          <div className="row-cotainer">
            <span className="empty-placeholder">11</span>
            <div>
              <div>Have you EVER had or been told you had or been treated for:</div>
              <YesNoChecks
                questionDesc="a) asthma, bronchitis, persistent cough, tuberculosis or respiratory disorder?"
                name="LungDisorder"
                validate={[validateRequired]}
              />
              <YesNoChecks
                questionDesc="b) epilepsy, fits, stroke, paralysis, weakness of limb, prolonged headache/giddiness, unconsciousness, nervous breakdown, depression or any other nervous/mental disorders or any disease of the brain?"
                name="MentalDisorders"
                validate={[validateRequired]}
              />
              <YesNoChecks
                questionDesc="c) gastritis, stomach or duodenal ulcer, blood in stools, fistula, piles or any other stomach or bowel disorders?"
                name="BowelDisorder"
                validate={[validateRequired]}
              />
              <YesNoChecks
                questionDesc="d) blood, protein or sugar in urine, kidney stones, infection or any other disorders of the kidney, bladder or genital organs?"
                name="KidneyDisorder"
                validate={[validateRequired]}
              />
              <YesNoChecks
                questionDesc="e) anaemia, diabetes, thyroid disorders or any other endocrine disorder?"
                name="BloodDisorder"
                validate={[validateRequired]}
              />
              <YesNoChecks
                questionDesc="f) cancer, tumour, cyst or growth of any kind?"
                name="Cancer"
                validate={[validateRequired]}
              />
              <YesNoChecks
                questionDesc="g) any form of eye, hearing or speech disorder or disease?"
                name="HearingAndSight"
                validate={[validateRequired]}
              />
              <YesNoChecks
                questionDesc="h) jaundice, Hepatitis B carrier or any form of hepatitis, liver or gallbladder disorders?"
                name="GallbladderDisorder"
                validate={[validateRequired]}
              />
              <YesNoChecks
                questionDesc="i) slipped disc, gout, arthritis, pain or deformity or disorders of the muscles, spine, limbs or joints or severe injury?"
                name="PhysicalInjury"
                validate={[validateRequired]}
              />
              <YesNoChecks
                questionDesc="j) raised cholesterol, high blood pressure, heart attack, heart murmur, irregular or fast heart rate, chest discomfort or pain, diseases or any other disorders of the heart, heart valves or blood vessels?"
                name="HeartDisorder"
                validate={[validateRequired]}
              />
              <YesNoChecks
                questionDesc="k) any other illness, disorder, injury, disability, operation or hospitalization not mention above?"
                name="PhysicalDisability"
                validate={[validateRequired]}
              />
              <em style={{ marginTop: "8px", display: "block" }}>
                If any of the answer to the above questions is ‘Yes’, please provide details as
                follows:
              </em>
              <table className="details-treatment">
                <tr>
                  <td rowSpan="2" width="5%">
                    Qn No.
                  </td>
                  <td rowSpan="2" width="25%">
                    Name of Condition
                  </td>
                  <td colSpan="2" width="15%">
                    Date
                  </td>
                  <td rowSpan="2" width="15%">
                    Type of test(s) done and result
                  </td>
                  <td rowSpan="2" width="15%">
                    Type of Treatment
                  </td>
                  <td rowSpan="2" width="25%">
                    Name & Address of Doctors / Clinics / Hospitals
                  </td>
                </tr>
                <tr>
                  <td width="7.5%">From</td>
                  <td width="7.5%">To</td>
                </tr>
                {[...Array(5).keys()].map(key => (
                  <tr key={key}>
                    <td>
                      <Field
                        name={`TreatmentNo${key + 1}`}
                        component={renderField}
                        showOuterDiv={false}
                        type="text"
                        validate={key === 0 && isQ11FieldsRequired && [validateRequired]}
                      />
                    </td>
                    <td>
                      <Field
                        name={`TreatmentCondition${key + 1}`}
                        component={renderField}
                        showOuterDiv={false}
                        type="text"
                        validate={key === 0 && isQ11FieldsRequired && [validateRequired]}
                      />
                    </td>
                    <td>
                      <Field
                        name={`TreatmentFrom${key + 1}`}
                        component={renderField}
                        showOuterDiv={false}
                        type="text"
                        validate={key === 0 && isQ11FieldsRequired && [validateRequired]}
                      />
                    </td>
                    <td>
                      <Field
                        name={`TreatmentTo${key + 1}`}
                        component={renderField}
                        showOuterDiv={false}
                        type="text"
                        validate={key === 0 && isQ11FieldsRequired && [validateRequired]}
                      />
                    </td>
                    <td>
                      <Field
                        name={`TreatmentResult${key + 1}`}
                        component={renderField}
                        showOuterDiv={false}
                        type="text"
                        validate={key === 0 && isQ11FieldsRequired && [validateRequired]}
                      />
                    </td>
                    <td>
                      <Field
                        name={`TreatmentType${key + 1}`}
                        component={renderField}
                        showOuterDiv={false}
                        type="text"
                        validate={key === 0 && isQ11FieldsRequired && [validateRequired]}
                      />
                    </td>
                    <td>
                      <Field
                        name={`TreatmentDoctor${key + 1}`}
                        component={renderField}
                        showOuterDiv={false}
                        type="text"
                        validate={key === 0 && isQ11FieldsRequired && [validateRequired]}
                      />
                    </td>
                  </tr>
                ))}
                <tr>
                  <td colSpan="7" style={{ textAlign: "left" }}>
                    <p>
                      Please provide copy of medical reports of the above-mentioned condition(s) for
                      our review (if available)
                    </p>
                    <div style={{ width: "500px", marginLeft: "-14px" }}>
                      <YesNo
                        reverse
                        name={"TreatmentDocument"}
                        labels={{
                          yes: "Yes (attached for your review)",
                          no: "No (report not available)",
                        }}
                        validate={isQ11FieldsRequired && [validateRequired]}
                      />
                    </div>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </fieldset>
    </form>
  );
};

StyledForm.propTypes = {
  renderValue: PropTypes.func.isRequired,
};

export default StyledForm;



// WEBPACK FOOTER //
// ./components/employee/hdf-forms/Prudential/Form202101/StyledForm.js